module.exports = __webpack_public_path__ + "static/media/adserver_decorative_section1.0c848b0c.png";